const Pattern = {
  username:
    "[A-Za-zÀ-ÖØ-Þà-öø-ÿ][A-Za-zÀ-ÖØ-Þà-öø-ÿ' \\-]{2,30}[A-Za-zÀ-ÖØ-Þà-öø-ÿ]",
  email: '[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}',
  // password: ".{8,}",
  password:
    // note that this does not specify a minimum length, this needs to be done in the form
    '(?!.*\\s\\s)(?:[^\\s]|\\s(?!\\s))*',
  // note that this does include a minimum lenght (8), and should match that in the form
  password_lookahead:
    '(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?!.*\\s\\s)(?:[^\\s]|\\s(?!\\s)){8,}',
} as const;

type PatternKey = keyof typeof Pattern;

export function getPattern(key: PatternKey, forHtml: boolean = true): string {
  if (key === 'password') {
    return forHtml ? Pattern.password : Pattern.password_lookahead;
  }
  return Pattern[key];
}
